export default function VehicleTypes() {
  const vehicles = [
    {
      type: 'SEDAN',
      title: 'Ambulatory Transport',
      capacity: 'Up to 3 passengers',
      price: '45',
      image: 'https://public.readdy.ai/ai/img_res/c02b38e7d56edd147c75c5d5ffb6b7e5.jpg'
    },
    {
      type: 'WHEELCHAIR VAN',
      title: 'Wheelchair Accessible',
      capacity: 'Hydraulic lift equipped',
      price: '75',
      image: 'https://readdy.ai/api/search-image?query=Wheelchair%20accessible%20van%20with%20hydraulic%20lift%20extended%2C%20modern%20medical%20transport%20vehicle%2C%20disability%20accessible%20transportation%2C%20professional%20healthcare%20van%20with%20ramp%2C%20simple%20clean%20background%20highlighting%20accessible%20features%2C%20white%20and%20blue%20medical%20vehicle&width=600&height=600&seq=vehicle-wheelchair-002&orientation=squarish'
    },
    {
      type: 'STRETCHER VEHICLE',
      title: 'Stretcher Transport',
      capacity: 'Medical-grade equipment',
      price: '95',
      image: 'https://readdy.ai/api/search-image?query=Medical%20stretcher%20transport%20vehicle%20interior%2C%20professional%20gurney%20equipped%20ambulance%2C%20healthcare%20stretcher%20transportation%20van%2C%20medical%20equipment%20vehicle%2C%20simple%20clean%20background%2C%20sterile%20professional%20medical%20transport%2C%20emergency%20medical%20vehicle%20interior&width=600&height=600&seq=vehicle-stretcher-003&orientation=squarish'
    },
    {
      type: 'BARIATRIC VAN',
      title: 'Bariatric Transport',
      capacity: 'Heavy-duty capacity',
      price: '110',
      image: 'https://readdy.ai/api/search-image?query=Bariatric%20medical%20transport%20van%2C%20heavy%20duty%20wheelchair%20accessible%20vehicle%2C%20extra%20wide%20medical%20transportation%2C%20specialized%20bariatric%20healthcare%20vehicle%2C%20reinforced%20medical%20transport%20van%2C%20simple%20clean%20background%2C%20professional%20heavy%20capacity%20transport&width=600&height=600&seq=vehicle-bariatric-004&orientation=squarish'
    }
  ];

  return (
    <section id="vehicles" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-6xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
            Our Fleet
          </h2>
          <p className="text-xl text-gray-600">
            Specialized vehicles for every mobility need
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {vehicles.map((vehicle, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative">
                <div className="w-full h-64">
                  <img
                    src={vehicle.image}
                    alt={vehicle.title}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div className="absolute top-4 right-4 bg-white px-4 py-2 rounded-lg shadow-md">
                  <span className="text-sm text-gray-600">Starting from</span>
                  <p className="text-2xl font-bold text-gray-900">${vehicle.price}</p>
                </div>
              </div>
              <div className="p-6">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-2">
                  {vehicle.type}
                </p>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {vehicle.title}
                </h3>
                <p className="text-sm text-gray-600">
                  {vehicle.capacity}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
